import { AppText, FlexRow } from 'src/style'
import React, { useState } from 'react'
import { Modal, Button, Text, Flex, tokens } from 'src/componentv2'
import {
    ONBOARDING_TERMS_MODAL_TITLE,
    ONBOARDING_TERMS_MODAL_BODY,
    ONBOARDING_TERMS_URL,
} from 'src/utils/onboardingPolicyCopy'

export interface TermsAcceptanceModalProps {
    open: boolean
    onClose: () => void
    onAccept: () => void
    termsUrl: string
    title?: string
    message?: React.ReactNode
}

// Prompts the user to open and review the Terms and Conditions before accepting.
// Accepting is what flips both the "agreed" flag and the dependency checkbox that
// triggered the prompt (e.g. streamlined onboarding) — declining leaves both untouched.
export const TermsAcceptanceModal: React.FC<TermsAcceptanceModalProps> = ({
    open, onClose, onAccept, termsUrl, title = ONBOARDING_TERMS_MODAL_TITLE, message = ONBOARDING_TERMS_MODAL_BODY,
}) => {
    const [ readTandC, setReadTandC ] = useState(false);
    return (
        <Modal open={open} onClose={onClose} title={title} maxWidth="44rem">
            <Text fontSize="1.4" color={tokens.textMuted}>
                {message}
            </Text>
            <Flex topMargin="1.6">
                <a href={termsUrl} target="_blank" rel="noopener noreferrer">
                    View Terms and Conditions
                </a>
            </Flex>
            <FlexRow gap='1' alignItems='flex-start' justifyContent="flex-start" style={{ marginTop: '0.8rem' }}>
                <input
                    type="checkbox"
                    checked={readTandC}
                    onChange={() => setReadTandC(!readTandC)}
                    style={{
                        width: '1.5rem',
                        height: '1.5rem',
                        borderRadius: '0.4rem',
                        border: '1px solid #D0D5DD',
                        cursor: 'pointer',
                        marginTop: '0.2rem',
                        accentColor: '#0D968F',
                        flexShrink: 0,
                    }}
                />
                <AppText textSize='1.2' color='#667085' fontWeight='500'>
                    I have read and agreed to the{" "}
                    <a
                        href={ONBOARDING_TERMS_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            fontWeight: 600,
                            color: '#0D968F',
                            textDecoration: 'none'
                        }}
                    >
                        Terms and Conditions
                    </a>{" "}
                    <span>
                        for streamlined onboarding.
                    </span>
                </AppText>
            </FlexRow>
            <Flex justify="flex-end" gap="1.2" topMargin="2.4">
                <Button variant="outline" onClick={onClose}>Cancel</Button>
                <Button variant="primary" onClick={onAccept} disabled={!readTandC}>I Agree</Button>
            </Flex>
        </Modal>)
}

export default TermsAcceptanceModal
